const faqs = [
  {
    q: '红桃影院观看电视剧真的完全免费吗？',
    a: '是的，红桃影院所有电视剧资源均免费提供观看，无需付费或会员订阅。我们通过广告合作维持平台运营，用户只需打开网页即可畅享高清追剧体验。',
  },
  {
    q: '剧集更新速度和视频清晰度如何？',
    a: '热播剧集通常在播出后 2 小时内完成更新，同步各大平台进度。视频提供 720P、1080P 多档清晰度选择，支持根据网络环境自适应调整，确保流畅播放。',
  },
  {
    q: '可以用手机或平板观看吗？',
    a: '完全支持！红桃影院采用响应式设计，在手机、平板、电脑上均可获得优质观影体验。我们还提供独立的 iOS 和 Android APP，支持离线缓存功能。',
  },
  {
    q: '韩剧和国产剧都有中文字幕吗？',
    a: '国产剧全集自带中文字幕，韩剧在线看均配有精准中文字幕翻译。我们的字幕团队会第一时间完成热门剧集的字幕制作，确保观看体验。',
  },
  {
    q: '需要注册账号才能观看吗？',
    a: '无需注册！红桃影院坚持零门槛追剧理念，打开网页即可直接观看所有内容。若想收藏剧集或同步观看进度，可选择免费注册账号使用更多功能。',
  },
  {
    q: '网站的剧集资源覆盖哪些类型？',
    a: '覆盖古装传奇、悬疑推理、都市情感、甜宠言情、历史正剧、奇幻仙侠、谍战军旅、青春校园、喜剧搞笑、韩剧精选等十余个品类，持续扩充中。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[860px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">常见问题</h2>
          <p className="text-sm text-foreground-500">关于红桃影院的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2">
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}